export default "__VITE_ASSET__e0746705__"